module.exports = __webpack_public_path__ + "static/img/merchant_new_3.49c9a70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/merchant_new_3.png
// module id = N7mg
// module chunks = 8